var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BlockRadioGroup"},_vm._l((_vm.list),function(i,index){return _c('div',{key:index,staticClass:"blockRadio"},[_c('div',{staticClass:"blockRadio_text",style:({
        color:i.selected?'rgba(25,137,250,1)':'#666666',
        border:i.selected?'1px solid rgba(25,137,250,1)':'1px solid #DADADA',
        backgroundColor: i.selected?'rgba(25,137,250,0.08)':''
      }),on:{"click":function($event){return _vm.select(i)}}},[_vm._v(_vm._s(i.value))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }